import { useReturnedFromLogin } from './useReturnedFromLogin';
import { type Dispatch, type SetStateAction, useEffect } from 'react';
import {
  isDiyWorkspace,
  isUnknownWorkspace,
} from '../selectors/workspace-selector';
import { getReturnToCurrentUrlFromLogin } from '../utils/getReturnToCurrentUrlFromLogin';
import { getFunnelLoginLink } from '../utils/getFunnelLinks';
import { useTemplatesData } from './useTemplatesData';
import { useQueryParams } from './useQueryParams';
import { QueryParams } from '../constants/QueryParams';
import { isQueryParamFlagsTrue } from '../utils/isQueryParamFlagsTrue';
import { ROUTES } from '../constants/routes';

export const useHandleFunnelRedirect = (
  setAppLoaded: Dispatch<SetStateAction<boolean>>,
) => {
  const { returnedFromLogin } = useReturnedFromLogin();
  const { getParam } = useQueryParams();
  const { workspace, isUserLoggedIn } = useTemplatesData();
  const loggedOutUser = !isUserLoggedIn;
  const isAutoRedirect = isQueryParamFlagsTrue(
    getParam(QueryParams.FUNNEL_AUTO_REDIRECT),
  );
  const redirectToFunnelBasicConditions = returnedFromLogin || isAutoRedirect;

  useEffect(() => {
    const workspaceDetermined = Boolean(workspace);
    const isDiy = isDiyWorkspace(workspace);
    const shouldRedirectDiyToFunnel = redirectToFunnelBasicConditions && isDiy;
    const doneWaitingForWorkspaceIfNeeded =
      loggedOutUser || workspaceDetermined;
    const { encodedCurrentUrl } = getReturnToCurrentUrlFromLogin();

    if (doneWaitingForWorkspaceIfNeeded) {
      if (isUnknownWorkspace(workspace)) {
        window.location.replace(
          ROUTES.loginPage({ postLogin: encodedCurrentUrl }),
        );
      } else if (shouldRedirectDiyToFunnel) {
        window.location.replace(getFunnelLoginLink(encodedCurrentUrl));
      } else {
        setAppLoaded(true);
      }
    }
  }, [loggedOutUser, redirectToFunnelBasicConditions, setAppLoaded, workspace]);
};
